<div class="row justify-content-center">
    <div class="col-lg-8">
        <div class="card">

            <div class="card-body">
                <form [formGroup]="registerForm" (ngSubmit)="register()">
                    <div class="form-body">
                        <h3 class="card-title">Crear usuario</h3>
                            <div class="row p-t-20">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Nombre</label>
                                    <input formControlName="name" type="text"  class="form-control" placeholder="Nombre">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Apellido</label>
                                    <input formControlName="surname" type="text"  class="form-control" placeholder="Apellido">
                                </div>
                            </div>
                            <!--/span-->
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Email</label>
                                    <input formControlName="email" type="email"  class="form-control" placeholder="Email">
                                </div>
                            </div>
                            <!--/span-->
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Rol</label>
                                    <select formControlName="role" class="form-control custom-select">
                                        <option value="admin">admin</option>
                                        <option value="client">client</option>
                                        <option value="evaluated">evaluated</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Contraseña</label>
                                    <input formControlName="password" type="password" class="form-control" placeholder="Contraseña">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Teléfono</label>
                                    <input formControlName="phone" type="text" class="form-control" placeholder="Teléfono">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Profesión</label>
                                    <input formControlName="profession" type="text" class="form-control" placeholder="Profesión">
                                </div>
                            </div>
                            <div class="col-md-6">    
                                <div class="form-group">
                                    <label class="control-label">Notas</label>
                                    <input formControlName="notes" type="text" class="form-control" placeholder="Notas">
                                </div>
                            </div>
                            <div class="col-md-6">    
                                <div class="form-group">
                                    <label class="control-label">Cantidad de pruebas</label>
                                    <input formControlName="remainingTests" type="number" class="form-control" placeholder="Cantidad de pruebas">
                                </div>
                            </div>
                        </div>


                        <div class="form-group">
                            <label class="control-label">País</label>
                            <input formControlName="country" type="text" class="form-control" placeholder="País">
                        </div><div class="form-group">
                            <label class="control-label">Ciudad</label>
                            <input formControlName="city" type="text" class="form-control" placeholder="Ciudad">
                        </div>
                        
                    </div>
                    <div class="form-actions">
                        <button type="submit" class="btn btn-success pull-right btn-rounded waves-effect">Guardar</button>
                        <button type="button" class="btn btn-inverse pull-right btn-rounded waves-effect" (click)="reset()">Reiniciar</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>